export default __webpack_public_path__ + "static/media/slider_2.2d268c83.webp";